import { schema } from "normalizr"

export const product = new schema.Entity(
  "products",
  {},
  { idAttribute: "droopyId" }
)
export const arrayOfProducts = new schema.Array(product)

export const field = new schema.Entity("fields", {}, { idAttribute: "name" })
export const arrayOfFields = new schema.Array(field)

export const family = new schema.Entity("families")
export const arrayOfFamilies = new schema.Array(family)